// API validation errors can be arrays/objects; never render them as React children.
export const apiError = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (typeof detail?.message === 'string') return detail.message;
  if (Array.isArray(detail)) return detail.map(item => item?.msg).filter(Boolean).join('; ') || fallback;
  if (error?.code === 'ECONNABORTED') return 'The request timed out. Check the player list before trying again.';
  return fallback;
};